import L from "leaflet";
export default L.icon({
  iconSize: [25, 41],
  iconAnchor: [10, 41],
  popupAnchor: [2, -40],
  iconUrl:"https://unpkg.com/leaflet@1.6/dist/images/marker-icon.png"
 
});